export default "__VITE_ASSET__b82548a4__"